<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container">
    <vs-row vs-w="12">
      <vs-col
        @click="navigateToDetail(list.id)"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="2"
        vs-sm="2"
        vs-xs="4"
        v-for="(list, index) in data"
        :key="index">
        <div
          @click="navigateToDetail(list.id)"
          class="vx-card p-0 idle-card vs-con-loading__container cursor-pointer"
          style="margin-bottom: 20px">
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body p-2">
              <div>
                <img
                  :src="getImageUrl(list.images)"
                  alt=""
                  style="margin: auto; width: 70%"
                  @error="handleImageError($event, list)" />
                <div class="titlecatpoi">
                  {{ list.catpoi_name }}
                </div>
                <div style="text-align: center; font-size: 12px">
                  {{ list.catpoi_code }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
// import FleetGroupForm from './FleetGroupForm.vue';

import * as REPO from '../../repository/index'
import { BASE_FILE } from '../../constant'

export default {
  data() {
    return {
      openModal: false,
      editMode: false,
      titleModal: 'Add New',
      selected: [],
      baseUrl: '',
      dataEdit: {},
      dataLevel: [],
      data: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
    }
  },
  beforeRouteLeave(to, from, next) {
    //
    this.closeModal()
    setTimeout(() => {
      next()
    }, 100)
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    getImageUrl() {
      return (path) => {
        if (!path) return ''

        // If path already includes http/https, return as is
        if (path.startsWith('http://') || path.startsWith('https://')) {
          return path
        }

        // If path starts with /, concatenate directly
        if (path.startsWith('/')) {
          return this.baseUrl + path
        }

        // Otherwise, add / before concatenating
        return this.baseUrl + '/' + path
      }
    },
  },
  methods: {
    navigateToDetail(id) {
      this.$router.push('/master-data/poi-detail/' + id)
    },
    addNew() {
      this.editMode = false
      this.titleModal = 'Add New'
      this.dataEdit = {}
      this.openModal = true
    },
    getData() {
      REPO.getListCategoryPOI()
        .then((res) => {
          this.data = res.data.data
          console.log('POI List Data:', this.data)
          if (this.data.length > 0) {
            console.log('POI Sample item:', this.data[0])
            console.log('POI Sample images path:', this.data[0].images)
            console.log('POI Full image URL (NEW):', this.getImageUrl(this.data[0].images))
          }
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        })
        .catch((err) => {
          //
        })
    },
    statusDescription(val) {
      if (val == 1) {
        return 'Active'
      } else {
        return 'Non Active'
      }
    },
    handleSelected(tr) {
      this.editMode = true
      this.titleModal = 'Update Data'
      this.dataEdit = JSON.parse(JSON.stringify(tr))
      this.openModal = true
    },
    closeModal() {
      this.openModal = false
    },
    submitModal() {
      this.openModal = false
      this.getData()
    },
    getStatusColor(status) {
      if (status == '0') return 'danger'
      if (status == '1') return 'success'
      return 'primary'
    },
    getPopularityColor(num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    formatData(data) {
      // formats data received from API
      let formattedData = data.map((item) => {
        const fields = item.fields
        let obj = {}
        for (const key of Object.keys(fields)) {
          obj[key] =
            fields[key].stringValue ||
            fields[key].integerValue ||
            fields[key].doubleValue
        }
        return obj
      })
      return formattedData
    },
    handleImageError(event, item) {
      console.error(`Image failed to load for ${item.catpoi_name}:`)
      console.error(`  Path: ${item.images}`)
      console.error(`  Full URL: ${this.getImageUrl(item.images)}`)
      console.error(`  Event:`, event)
    },
  },
  created() {
    this.baseUrl = BASE_FILE.substring(0, BASE_FILE.length - 4)
    console.log('POI - BASE_FILE:', BASE_FILE)
    console.log('POI - baseUrl:', this.baseUrl)

    this.getData()
  },
  mounted() {
    this.$vs.loading({
      container: '#data-list-list-view',
      scale: 1,
    })

    this.isMounted = true
  },
}
</script>

<style lang="scss" scoped>
.titlecatpoi {
  text-align: center;
  font-weight: bold;
  margin-top: 10px;
}
</style>
